module.exports = __webpack_public_path__ + "static/img/mark3-BGnW_V-t.b41e083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/mark3-BGnW_V-t.png
// module id = oqb8
// module chunks = 16